import React from 'react';
import ScoringSuccess from '../ScoringSuccess/ScoringSuccess';

/**
 * Компонент контента модального окна прескоринга на стадии Accept
 * (с результатами скоринга)
 */
export default function StageApprove() {
    return (
        <ScoringSuccess
            title="Возобновляемая линия займа предварительно одобрена"
            masked={false}
        />
    );
}